import * as React from 'react';
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// Initialize Firebase
const firebaseConfig = JSON.parse(import.meta.env.VITE_FIREBASE_CLIENT_CONFIG);
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

export const getBaseURL = () => {
    const { VITE_CLIENT_BASE_URL } = import.meta.env;
    return VITE_CLIENT_BASE_URL || 'http://localhost:5173';
};

export const FirebaseContext = React.createContext([{}, () => {}]);
